export default "__VITE_ASSET__BOOxN3od__"